export default "__VITE_ASSET__ab15bf24__"